import React from 'react'
import { TextField } from '@cicero/ui'
import { HasNoValue, HasValue, TextEquals, TextLike } from './conditions'
import { IPageFilterOption } from './helpers'
import { TemplateChooser } from 'forms/TemplateChooser'
import { PageChooser } from 'forms/PageChooser'
import { PageDoc, PageTemplateDoc } from 'models'

const conditions = [TextEquals, TextLike, HasValue] // default basic conditions

export const PageTitleFilter: IPageFilterOption<string> = {
  id: 'page_title',
  label: 'Title',
  key: 'title',
  type: 'page',
  conditions,
  renderForm(value, setValue) {
    return <TextField variant="outlined" value={value} onChange={(e) => setValue(e.target.value)} />
  },
}

export const PageTemplateFilter: IPageFilterOption<PageTemplateDoc> = {
  id: 'page_template',
  label: 'Template',
  key: 'template_id',
  type: 'page',
  conditions: [TextEquals, HasValue, HasNoValue],
  prepareTerm(doc) { return typeof doc === 'string' ? doc : doc?.id || true },
  renderForm(value, setValue) {
    return <TemplateChooser
      name="query_template"
      value={value}
      onChange={(e) => setValue(e.target.value)}
    />
  },
}

export const PageParentFilter: IPageFilterOption<PageDoc> = {
  id: 'page_parent',
  label: 'Parent',
  key: 'parent_id',
  type: 'page',
  conditions: [TextEquals, HasValue, HasNoValue],
  prepareTerm(doc) { return typeof doc === 'string' ? doc : doc?.id || true },
  renderForm(value, setValue) {
    return <PageChooser
      name="query_parent"
      value={value}
      onChange={(e) => setValue(e.target.value)}
    />
  },
}
